import { Link } from "react-router-dom";
import { Icon } from "semantic-ui-react";
import { purchaseStickerTokensQuantity } from "../../lib/storefront";
import { type StorefrontCartLineHeavyFragment } from "../../client/MapmakerApi";
import { StickerTokenIcon } from "../shared/icons/StickerTokenIcon";
import LineItem from "./LineItem";
import { useMapmakerAppConfig } from "../..";
import "./PurchaseStickerTokensLineItem.css";

type IPurchaseStickerTokensLineItemProps = {
  line: StorefrontCartLineHeavyFragment;
  willBeMailed: boolean;
};

export default function PurchaseStickerTokensLineItem({
  line,
  willBeMailed,
}: IPurchaseStickerTokensLineItemProps) {
  const { gotoProduct } = useMapmakerAppConfig();
  if (!line.merchandise) {
    throw new Error("Variant not found for purchase sticker tokens line item.");
  }

  const tokenQuantity = purchaseStickerTokensQuantity(line.merchandise);
  const prettyQuantity =
    tokenQuantity === 1 ? "1 Sticker Token" : `${tokenQuantity} Sticker Tokens`;

  return (
    <LineItem
      title={
        line.quantity === 1
          ? prettyQuantity
          : `${line.quantity} ✕ ${prettyQuantity}`
      }
      onProductNameClick={() => gotoProduct(line.merchandise.product.handle)}
      thumbnail={<StickerTokenIcon size={100} style={{ padding: "1rem" }} />}
      price={line.cost.subtotalAmount}
      lineIds={[line.id]}
      // Need to fix if we want discount allocations.
      discountAllocations={[]}
    >
      <div id="purchase-sticker-tokens-line-item">
        {willBeMailed ? (
          <p>
            {line.quantity === 1
              ? "A unique code"
              : `${line.quantity} unique codes`}{" "}
            redeemable for {prettyQuantity} will be included in the package with
            this order. The same {line.quantity === 1 ? "code" : "codes"} will
            also be emailed to the <i>buyers</i> email address.
          </p>
        ) : (
          <p>
            After placing your order{" "}
            {line.quantity === 1
              ? "a unique code"
              : `${line.quantity} unique codes`}{" "}
            redeemable for {prettyQuantity} will be emailed to you. You can use
            the {line.quantity === 1 ? "code" : "codes"} to redeem the tokens on
            your own account or you can give{" "}
            {line.quantity === 1 ? "it" : "them"} to someone else to redeem on
            their account.
          </p>
        )}
        <p className="note">
          <Icon name="info circle" />
          For more information about sticker tokens see{" "}
          <Link to={`/help/sticker-tokens`}>this page</Link>{" "}
        </p>
      </div>
    </LineItem>
  );
}
